import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

interface Toast { id: number; texto: string; tipo: 'ok' | 'erro' | 'info' }
interface Api {
  ok: (t: string) => void;
  erro: (t: string | Error) => void;
  info: (t: string) => void;
}
const Ctx = createContext<Api | null>(null);
let seq = 1;

export function ToastProvider({ children }: { children: ReactNode }) {
  const [lista, setLista] = useState<Toast[]>([]);
  const push = useCallback((texto: string, tipo: Toast['tipo']) => {
    const id = seq++;
    setLista((l) => [...l, { id, texto, tipo }]);
    setTimeout(() => setLista((l) => l.filter((t) => t.id !== id)), tipo === 'erro' ? 6000 : 3500);
  }, []);
  const api = useMemo<Api>(() => ({
    ok: (t) => push(t, 'ok'),
    erro: (t) => push(t instanceof Error ? t.message : t, 'erro'),
    info: (t) => push(t, 'info'),
  }), [push]);
  return (
    <Ctx.Provider value={api}>
      {children}
      <div className="toasts" aria-live="polite">
        {lista.map((t) => <div key={t.id} className={`toast ${t.tipo}`}>{t.texto}</div>)}
      </div>
    </Ctx.Provider>
  );
}

export function useToast(): Api {
  const a = useContext(Ctx);
  if (!a) throw new Error('useToast fora do ToastProvider');
  return a;
}
